import { IUnitFormatting } from "@gtmhub/shared/models";
import { IComponentOptions, IController } from "angular";
import { IMetric } from "../../models/models";

interface ICascadingMetricValuesAffixInputBindings {
  format: IUnitFormatting;
  metric: IMetric;
  isInitialValue: boolean;
  onChange(): void;
}

/**
 * This component is used to display prefix or suffix of a given metric's initial and target values
 * @example cascading-metric-values-affix-input(format="$ctrl.metric.format" value="$ctrl.metric.initialValue" actual-value="$ctrl.metric.actualValue" on-change="$ctrl.onChange()")
 * @param format - format of the affixes
 * @param metric - metric whose initial and target we want to display
 * @param isInitialValue - are we visualizing the initial value or the target value
 * @param onChange - calculates the contribution values based on the metric value
 */

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CascadingMetricValuesAffixInputCtrl extends ICascadingMetricValuesAffixInputBindings {}
export class CascadingMetricValuesAffixInputCtrl implements IController {
  isContributingMetricWithSuffix: boolean;
  isContributingMetricWithPrefix: boolean;

  $onInit(): void {
    this.isContributingMetricWithSuffix = !!this.format?.suffix;
    this.isContributingMetricWithPrefix = !!this.format?.prefix;
  }
}

export const CascadingMetricValuesAffixInputComponent: IComponentOptions = {
  controller: CascadingMetricValuesAffixInputCtrl,
  templateUrl: require("./cascading-metric-values-affix-input.jade"),
  bindings: {
    format: "<",
    metric: "<",
    isInitialValue: "<",
    onChange: "&",
  },
};
